// import React, { useContext, useEffect, useState } from 'react'
// import { summaryApi } from '../../common';
// import Context from '../../context';
// import { useTheme } from '../../components/Theme/ThemeProvider';
// import { MdDelete } from 'react-icons/md';
// import { FaPlus, FaMinus, FaShoppingCart, FaTruck, FaLock, FaStar } from 'react-icons/fa';
// import { displayNGNCurrency } from '../../helpers/displayCurrency';
// import { Link } from 'react-router-dom';
// import { Trash2, ArrowRight } from 'lucide-react';

// function Cart() {
//     const { colors } = useTheme();
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [removingId, setRemovingId] = useState(null);
//     const [updatingId, setUpdatingId] = useState(null);
//     const context = useContext(Context);

//     const fetchData = async () => {
//     try {
//         setLoading(true);
//         const response = await fetch(summaryApi.cartList.url, {
//             method: summaryApi.cartList.method,
//             credentials: "include",
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
//         const responseData = await response.json();

//         console.log('📦 Cart API Response:', responseData); // Debug log

//         if (responseData.success) {
//             // Handle different response structures
//             let cartData = [];
            
//             if (Array.isArray(responseData.data)) {
//                 // New structure: array of cart items with productDetails
//                 cartData = responseData.data;
//             } else if (responseData.data && responseData.data.cartItems && responseData.data.products) {
//                 // Old structure: separate cartItems and products
//                 cartData = responseData.data.cartItems.products.map(cartItem => {
//                     const product = responseData.data.products.find(
//                         p => p._id === cartItem.productId
//                     );
//                     return {
//                         ...cartItem,
//                         productDetails: product
//                     };
//                 });
//             }
            
//             setData(cartData);
//         } else {
//             setData([]);
//         }
//     } catch (error) {
//         console.error('Error fetching cart data:', error);
//         setData([]);
//     } finally {
//         setLoading(false);
//     }
// };

//     const handleUpdateQuantity = async (cartItemId, qty) => {
//         if (qty < 1) return;
        
//         setUpdatingId(cartItemId);
//         try {
//             const response = await fetch(summaryApi.updateCart.url, {
//                 method: summaryApi.updateCart.method,
//                 credentials: "include",
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     _id: cartItemId,
//                     quantity: qty
//                 })
//             });

//             const responseData = await response.json();
//             if (responseData.success) {
//                 await fetchData();
//                 context.fetchUserAddToCart();
//             }
//         } catch (error) {
//             console.error('Error updating cart item:', error);
//         } finally {
//             setUpdatingId(null);
//         }
//     };

//     const handleRemoveCart = async (cartItemId) => {
//         setRemovingId(cartItemId);
//         try {
//             const response = await fetch(summaryApi.deleteCart.url, {
//                 method: summaryApi.deleteCart.method,
//                 credentials: "include",
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({ _id: cartItemId })
//             });

//             const responseData = await response.json();
//             if (responseData.success) {
//                 await fetchData();
//                 context.fetchUserAddToCart();
//             }
//         } catch (error) {
//             console.error('Error removing cart item:', error);
//         } finally {
//             setRemovingId(null);
//         }
//     };

//     const calculateTotal = () => {
//     return data.reduce((total, cartItem) => {
//         // Try different possible price locations
//         const price = 
//             cartItem.productDetails?.productPrice || 
//             cartItem.productPrice || 
//             cartItem.price || 
//             0;
        
//         const quantity = cartItem.quantity || 1;
//         return total + (quantity * price);
//     }, 0);
// };

//     useEffect(() => {
//         fetchData();
//     }, []);

//     // Loading Skeleton
//     if (loading) {
//         return (
//             <div className='min-h-screen transition-colors duration-300 mt-20' style={{ backgroundColor: colors.bg }}>
//                 <div className='container mx-auto px-4 py-12'>
//                     <div className='max-w-6xl mx-auto'>
//                         {/* Header Skeleton */}
//                         <div className='mb-12 h-12 rounded-lg animate-pulse' style={{ backgroundColor: colors.bgTertiary }} />
                        
//                         {/* Items Skeleton */}
//                         <div className='space-y-6 mb-8'>
//                             {[...Array(3)].map((_, i) => (
//                                 <div 
//                                     key={i}
//                                     className='p-6 rounded-xl animate-pulse'
//                                     style={{ backgroundColor: colors.bgSecondary }}
//                                 >
//                                     <div className='flex gap-6'>
//                                         <div className='w-24 h-24 rounded-lg' style={{ backgroundColor: colors.bgTertiary }} />
//                                         <div className='flex-1 space-y-3'>
//                                             <div className='h-4 w-1/2 rounded' style={{ backgroundColor: colors.bgTertiary }} />
//                                             <div className='h-4 w-1/3 rounded' style={{ backgroundColor: colors.bgTertiary }} />
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>

//                         {/* Summary Skeleton */}
//                         <div className='h-16 rounded-lg animate-pulse' style={{ backgroundColor: colors.bgTertiary }} />
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     // Empty Cart State
//     if (data.length === 0) {
//         return (
//             <div className='min-h-screen transition-colors duration-300 mt-20' style={{ backgroundColor: colors.bg }}>
//                 <div className='container mx-auto px-4 py-16'>
//                     <div 
//                         className='max-w-2xl mx-auto text-center p-12 rounded-2xl'
//                         style={{
//                             background: `linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.accentLight} 100%)`,
//                             border: `2px dashed ${colors.primary}`
//                         }}
//                     >
//                         <div className='mb-6'>
//                             <FaShoppingCart 
//                                 size={64}
//                                 style={{ color: colors.primary }}
//                                 className='mx-auto animate-bounce'
//                             />
//                         </div>
//                         <h2 
//                             className='text-3xl font-black mb-3'
//                             style={{ color: colors.text }}
//                         >
//                             Your Cart is Empty
//                         </h2>
//                         <p 
//                             className='text-lg mb-8'
//                             style={{ color: colors.textSecondary }}
//                         >
//                             Looks like you haven't added any items yet. Explore our amazing products!
//                         </p>
//                         <Link 
//                             to="/"
//                             className='inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-bold transition-all hover:scale-105 hover:shadow-lg'
//                             style={{
//                                 background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                             }}
//                         >
//                             Continue Shopping
//                             <ArrowRight size={20} />
//                         </Link>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     // Cart with Items
//     return (
//         <div className='min-h-screen transition-colors duration-300 mt-20 pb-12' style={{ backgroundColor: colors.bg }}>
//             <div className='container mx-auto px-4 py-8'>
//                 <div className='max-w-6xl mx-auto'>
//                     {/* Header */}
//                     <div className='mb-12'>
//                         <div className='flex items-center gap-3 mb-4'>
//                             <FaShoppingCart size={32} style={{ color: colors.primary }} />
//                             <h1 
//                                 className='text-4xl font-black'
//                                 style={{ color: colors.text }}
//                             >
//                                 Shopping Cart
//                             </h1>
//                         </div>
//                         <div 
//                             className='h-1 w-20 rounded-full'
//                             style={{ backgroundColor: colors.primary }}
//                         />
//                     </div>

//                     <div className='grid lg:grid-cols-3 gap-8'>
//                         {/* Cart Items */}
//                         <div className='lg:col-span-2'>
//                             <div 
//                                 className='rounded-2xl overflow-hidden'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <div className='space-y-4 p-6'>
//                                     {data.map((cartItem, index) => {
//     // Safely extract product information
//     const productDetails = cartItem.productDetails || cartItem;
//     const productName = productDetails.productName || 'Unknown Product';
//     const category = productDetails.productsCategory || 'Unknown Category';
    
//     // Try multiple possible price locations
//     const price = 
//         productDetails.productPrice || 
//         cartItem.productPrice || 
//         productDetails.price || 
//         0;
    
//     const image = (productDetails.productImage || [])[0] || '';
//     const quantity = cartItem.quantity || 1;
//     const productId = cartItem.productId || cartItem._id;
//     const cartItemId = cartItem._id;
    
//     const isRemoving = removingId === cartItemId;
//     const isUpdating = updatingId === cartItemId;

//     // Get variant information
//     const variants = [
//         cartItem.storage,
//         cartItem.color, 
//         cartItem.ram,
//         cartItem.processor,
//         cartItem.screenSize
//     ].filter(v => v && v.trim() !== '');

//     return (
//         <div
//             key={cartItemId}
//             className={`flex flex-col sm:flex-row gap-4 p-4 rounded-xl transition-all duration-300 hover:shadow-lg ${
//                 isRemoving ? 'opacity-50 scale-95' : ''
//             }`}
//             style={{
//                 backgroundColor: colors.bgTertiary,
//                 border: `1px solid ${colors.border}`
//             }}
//         >
//             {/* Product Image */}
//             <Link 
//                 to={`/product/${productId}`}
//                 className='flex-shrink-0 overflow-hidden rounded-lg transition-transform hover:scale-110'
//                 style={{
//                     backgroundColor: colors.bg
//                 }}
//             >
//                 <img
//                     src={image}
//                     alt={productName}
//                     className='w-24 h-24 object-scale-down p-2'
//                 />
//             </Link>

//             {/* Product Details */}
//             <div className='flex-grow min-w-0'>
//                 <Link 
//                     to={`/product/${productId}`}
//                     className='block'
//                 >
//                     <h3 
//                         className='font-bold text-lg line-clamp-2 hover:opacity-70 transition-opacity'
//                         style={{ color: colors.text }}
//                     >
//                         {productName}
//                     </h3>
//                 </Link>
//                 <p 
//                     className='text-sm'
//                     style={{ color: colors.textSecondary }}
//                 >
//                     {category}
//                 </p>
                
//                 {/* Display Variants */}
//                 {variants.length > 0 && (
//                     <div className='mt-2 flex flex-wrap gap-1'>
//                         {variants.map((variant, idx) => (
//                             <span
//                                 key={idx}
//                                 className='px-2 py-1 text-xs rounded-full font-medium'
//                                 style={{
//                                     backgroundColor: colors.primaryLight,
//                                     color: colors.primary
//                                 }}
//                             >
//                                 {variant}
//                             </span>
//                         ))}
//                     </div>
//                 )}
                
//                 <p 
//                     className='font-bold text-lg mt-2'
//                     style={{ color: colors.primary }}
//                 >
//                     {displayNGNCurrency(price)}
//                 </p>
//             </div>

//             {/* Quantity Control & Remove */}
//             <div className='flex items-center justify-between sm:flex-col gap-4'>
//                 {/* Quantity Selector */}
//                 <div 
//                     className='flex items-center gap-2 px-3 py-2 rounded-lg'
//                     style={{
//                         backgroundColor: colors.bg,
//                         border: `1px solid ${colors.border}`
//                     }}
//                 >
//                     <button
//                         onClick={() => handleUpdateQuantity(cartItemId, quantity - 1)}
//                         disabled={quantity <= 1 || isUpdating}
//                         className='p-1 rounded transition-all hover:scale-110 disabled:opacity-50'
//                         style={{
//                             backgroundColor: `${colors.accent}20`,
//                             color: colors.accent
//                         }}
//                     >
//                         <FaMinus size={14} />
//                     </button>
//                     <span 
//                         className='font-bold w-8 text-center'
//                         style={{ color: colors.text }}
//                     >
//                         {quantity}
//                     </span>
//                     <button
//                         onClick={() => handleUpdateQuantity(cartItemId, quantity + 1)}
//                         disabled={isUpdating}
//                         className='p-1 rounded transition-all hover:scale-110 disabled:opacity-50'
//                         style={{
//                             backgroundColor: `${colors.primary}20`,
//                             color: colors.primary
//                         }}
//                     >
//                         <FaPlus size={14} />
//                     </button>
//                 </div>

//                 {/* Price & Remove */}
//                 <div className='text-right'>
//                     <p 
//                         className='font-black text-lg'
//                         style={{ color: colors.primary }}
//                     >
//                         {displayNGNCurrency(quantity * price)}
//                     </p>
//                     <button
//                         onClick={() => handleRemoveCart(cartItemId)}
//                         disabled={isRemoving}
//                         className='mt-2 p-2 rounded-lg transition-all hover:scale-110 disabled:opacity-50'
//                         style={{
//                             backgroundColor: `${colors.accent}20`,
//                             color: colors.accent
//                         }}
//                         title="Remove from cart"
//                     >
//                         <Trash2 size={20} />
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// })}
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Order Summary */}
//                         <div className='lg:col-span-1'>
//                             <div 
//                                 className='rounded-2xl p-6 sticky top-32 transition-all duration-300'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `2px solid ${colors.primary}`
//                                 }}
//                             >
//                                 {/* Order Summary Title */}
//                                 <h2 
//                                     className='text-2xl font-black mb-6'
//                                     style={{ color: colors.text }}
//                                 >
//                                     Order Summary
//                                 </h2>

//                                 {/* Summary Details */}
//                                 <div className='space-y-4 mb-6'>
//                                     {/* Items Count */}
//                                     <div className='flex justify-between text-sm'>
//                                         <span style={{ color: colors.textSecondary }}>Items ({data.length})</span>
//                                         <span 
//                                             className='font-bold'
//                                             style={{ color: colors.text }}
//                                         >
//                                             {displayNGNCurrency(calculateTotal())}
//                                         </span>
//                                     </div>

//                                     {/* Shipping */}
//                                     <div className='flex justify-between text-sm'>
//                                         <span style={{ color: colors.textSecondary }}>Shipping</span>
//                                         <span 
//                                             className='font-bold'
//                                             style={{ color: colors.accent }}
//                                         >
//                                             Free
//                                         </span>
//                                     </div>

//                                     {/* Divider */}
//                                     <div style={{ borderTop: `1px solid ${colors.border}` }} />

//                                     {/* Total */}
//                                     <div className='flex justify-between text-lg'>
//                                         <span 
//                                             className='font-black'
//                                             style={{ color: colors.text }}
//                                         >
//                                             Total:
//                                         </span>
//                                         <span 
//                                             className='font-black'
//                                             style={{ color: colors.primary }}
//                                         >
//                                             {displayNGNCurrency(calculateTotal())}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 {/* Benefits */}
//                                 <div className='space-y-3 mb-8 pb-8' style={{ borderBottom: `1px solid ${colors.border}` }}>
//                                     {[
//                                         { icon: FaTruck, text: 'Free Shipping' },
//                                         { icon: FaLock, text: 'Secure Payment' },
//                                         { icon: FaStar, text: 'Premium Support' }
//                                     ].map((benefit, i) => (
//                                         <div key={i} className='flex items-center gap-3 text-sm'>
//                                             <div 
//                                                 className='p-2 rounded-lg'
//                                                 style={{
//                                                     backgroundColor: `${colors.primary}20`,
//                                                     color: colors.primary
//                                                 }}
//                                             >
//                                                 <benefit.icon size={16} />
//                                             </div>
//                                             <span style={{ color: colors.textSecondary }}>
//                                                 {benefit.text}
//                                             </span>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 {/* Checkout Button */}
//                                 <Link
//                                     to="/checkout"
//                                     className='w-full py-4 rounded-lg font-bold text-white transition-all hover:scale-105 hover:shadow-lg flex items-center justify-center gap-2'
//                                     style={{
//                                         background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                                     }}
//                                 >
//                                     <FaShoppingCart />
//                                     Proceed to Checkout
//                                 </Link>

//                                 {/* Continue Shopping */}
//                                 <Link
//                                     to="/"
//                                     className='w-full mt-3 py-3 rounded-lg font-bold transition-all text-center border-2'
//                                     style={{
//                                         borderColor: colors.primary,
//                                         color: colors.primary,
//                                         backgroundColor: 'transparent'
//                                     }}
//                                 >
//                                     Continue Shopping
//                                 </Link>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <style jsx>{`
//                 @keyframes slideIn {
//                     from {
//                         opacity: 0;
//                         transform: translateX(-20px);
//                     }
//                     to {
//                         opacity: 1;
//                         transform: translateX(0);
//                     }
//                 }

//                 @keyframes fadeInScale {
//                     from {
//                         opacity: 0;
//                         transform: scale(0.95);
//                     }
//                     to {
//                         opacity: 1;
//                         transform: scale(1);
//                     }
//                 }

//                 div {
//                     animation: fadeInScale 0.3s ease-out;
//                 }
//             `}</style>
//         </div>
//     );
// }

// export default Cart;





import React, { useContext, useEffect, useState } from 'react'
import { summaryApi } from '../../common';
import Context from '../../context';
import { MdDelete } from 'react-icons/md';
import { FaPlus, FaMinus, FaShoppingCart, FaTruck, FaLock, FaStar } from 'react-icons/fa';
import { displayNGNCurrency } from '../../helpers/displayCurrency';
import { Link } from 'react-router-dom';
import { Trash2, ArrowRight, ShoppingCart, Check, ChevronRight } from 'lucide-react';
import { authFetch } from '../../helpers/authFetch';

function Cart() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [removingId, setRemovingId] = useState(null);
    const [updatingId, setUpdatingId] = useState(null);
    const context = useContext(Context);

    // Elegant color palette matching ProductDetails
    const colors = {
        primary: '#1a365d', // Elegant dark blue
        accent: '#7c3aed', // Elegant purple
        bg: '#fafafa', // Light background
        bgSecondary: '#ffffff', // White background
        bgTertiary: '#f5f5f5', // Light gray background
        text: '#171717', // Dark text
        textSecondary: '#525252', // Medium gray text
        border: '#d4d4d4', // Light border
        shadow: 'rgba(0, 0, 0, 0.05)',
        success: '#10b981'
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await authFetch(summaryApi.cartList.url, {
                method: summaryApi.cartList.method,
                
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const responseData = await response.json();

            if (responseData.success) {
                let cartData = [];
                
                if (Array.isArray(responseData.data)) {
                    cartData = responseData.data;
                } else if (responseData.data && responseData.data.cartItems && responseData.data.products) {
                    cartData = responseData.data.cartItems.products.map(cartItem => {
                        const product = responseData.data.products.find(
                            p => p._id === cartItem.productId
                        );
                        return {
                            ...cartItem,
                            productDetails: product
                        };
                    });
                }
                
                setData(cartData);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error('Error fetching cart data:', error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateQuantity = async (cartItemId, qty) => {
        if (qty < 1) return;
        
        setUpdatingId(cartItemId);
        try {
            const response = await authFetch(summaryApi.updateCart.url, {
                method: summaryApi.updateCart.method,
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    _id: cartItemId,
                    quantity: qty
                })
            });

            const responseData = await response.json();
            if (responseData.success) {
                await fetchData();
                context.fetchUserAddToCart();
            }
        } catch (error) {
            console.error('Error updating cart item:', error);
        } finally {
            setUpdatingId(null);
        }
    };

    const handleRemoveCart = async (cartItemId) => {
        setRemovingId(cartItemId);
        try {
            const response = await authFetch(summaryApi.deleteCart.url, {
                method: summaryApi.deleteCart.method,
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ _id: cartItemId })
            });

            const responseData = await response.json();
            if (responseData.success) {
                await fetchData();
                context.fetchUserAddToCart();
            }
        } catch (error) {
            console.error('Error removing cart item:', error);
        } finally {
            setRemovingId(null);
        }
    };

    const calculateTotal = () => {
        return data.reduce((total, cartItem) => {
            const price = 
                cartItem.productDetails?.productPrice || 
                cartItem.productPrice || 
                cartItem.price || 
                0;
            
            const quantity = cartItem.quantity || 1;
            return total + (quantity * price);
        }, 0);
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Loading Skeleton
    if (loading) {
        return (
            <div className='min-h-screen bg-neutral-50 pt-16' style={{ fontFamily: 'Georgia, serif' }}>
                <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8'>
                    <div className='max-w-6xl mx-auto'>
                        {/* Header Skeleton */}
                        <div className='mb-8 sm:mb-12'>
                            <div className='h-8 sm:h-10 w-40 sm:w-48 bg-neutral-200 animate-pulse mb-3 sm:mb-4' />
                            <div className='h-px w-16 bg-neutral-300' />
                        </div>
                        
                        {/* Cart Items Skeleton */}
                        <div className='space-y-4 sm:space-y-6'>
                            {[...Array(3)].map((_, i) => (
                                <div 
                                    key={i}
                                    className='p-4 sm:p-6 rounded-lg border border-neutral-300 animate-pulse bg-neutral-100'
                                >
                                    <div className='flex gap-4 sm:gap-6'>
                                        <div className='w-20 h-20 sm:w-28 sm:h-28 bg-neutral-200 rounded-lg flex-shrink-0' />
                                        <div className='flex-1 space-y-2 sm:space-y-3'>
                                            <div className='h-4 w-3/4 bg-neutral-200 rounded' />
                                            <div className='h-4 w-1/2 bg-neutral-200 rounded' />
                                            <div className='h-6 w-32 bg-neutral-200 rounded' />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Empty Cart State
    if (data.length === 0) {
        return (
            <div className='min-h-screen bg-neutral-50 pt-16 flex items-center justify-center' style={{ fontFamily: 'Georgia, serif' }}>
                <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16'>
                    <div 
                        className='max-w-2xl mx-auto text-center p-6 sm:p-8 md:p-16 border border-neutral-300 bg-white rounded-lg'
                    >
                        <div className='mb-6 sm:mb-8'>
                            <ShoppingCart 
                                size={60}
                                className='mx-auto text-neutral-600 mb-4 sm:mb-6'
                            />
                        </div>
                        <h2 
                            className='text-2xl sm:text-3xl font-normal mb-3 sm:mb-4 text-neutral-900 tracking-tight'
                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                        >
                            Your Cart is Empty
                        </h2>
                        <p 
                            className='text-sm sm:text-base mb-8 sm:mb-10 text-neutral-600 leading-relaxed px-2 sm:px-0'
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            You haven't added any items to your cart yet. Explore our premium collection to find your perfect device.
                        </p>
                        <Link 
                            to="/"
                            className='inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 text-xs sm:text-sm uppercase tracking-wider text-neutral-200 font-medium transition-all hover:scale-[1.02] hover:shadow-lg bg-neutral-900 border border-neutral-900'
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            Continue Shopping
                            <ArrowRight size={16} className='sm:hidden' />
                            <ChevronRight size={18} className='hidden sm:block' />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    // Cart with Items
    return (
        <div className='min-h-screen bg-neutral-50 mt-[-30px] pb-12 sm:pb-16' style={{ fontFamily: 'Georgia, serif' }}>
            <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8'>
                <div className='max-w-6xl mx-auto'>
                    {/* Header */}
                    <div className='mb-8 sm:mb-12'>
                        <h1 
                            className='text-2xl sm:text-3xl lg:text-4xl font-normal mb-3 sm:mb-4 text-neutral-900 tracking-tight'
                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                        >
                            Shopping Cart
                        </h1>
                        <div className='h-px w-16 bg-neutral-300' />
                        <p className='text-sm text-neutral-600 mt-2 sm:mt-3' style={{ fontFamily: 'Georgia, serif' }}>
                            {data.length} item{data.length !== 1 ? 's' : ''} in your cart
                        </p>
                    </div>

                    <div className='lg:grid lg:grid-cols-3 lg:gap-12'>
                        {/* Cart Items - Full width on mobile, 2/3 on desktop */}
                        <div className='lg:col-span-2 mb-8 lg:mb-0'>
                            <div className='space-y-4 sm:space-y-6'>
                                {data.map((cartItem, index) => {
                                    const productDetails = cartItem.productDetails || cartItem;
                                    const productName = productDetails.productName || 'Unknown Product';
                                    const category = productDetails.productsCategory || 'Unknown Category';
                                    
                                    const price = 
                                        productDetails.productPrice || 
                                        cartItem.productPrice || 
                                        productDetails.price || 
                                        0;
                                    
                                    const image = (productDetails.productImage || [])[0] || '';
                                    const quantity = cartItem.quantity || 1;
                                    const productId = cartItem.productId || cartItem._id;
                                    const cartItemId = cartItem._id;
                                    
                                    const isRemoving = removingId === cartItemId;
                                    const isUpdating = updatingId === cartItemId;

                                    // Get variant information
                                    const variants = [
                                        cartItem.storage,
                                        cartItem.color, 
                                        cartItem.ram,
                                        cartItem.processor,
                                        cartItem.screenSize
                                    ].filter(v => v && v.trim() !== '');

                                    return (
                                        <div
                                            key={cartItemId}
                                            className={`p-4 sm:p-6 border border-neutral-300 bg-white rounded-lg transition-all duration-300 ${
                                                isRemoving ? 'opacity-50' : ''
                                            }`}
                                        >
                                            <div className='flex flex-col sm:flex-row gap-4 sm:gap-6'>
                                                {/* Product Image */}
                                                <Link 
                                                    to={`/product/${productId}`}
                                                    className='flex-shrink-0 self-center sm:self-start'
                                                >
                                                    <div className='w-24 h-24 sm:w-32 sm:h-32 bg-neutral-100 border border-neutral-300 flex items-center justify-center overflow-hidden'>
                                                        <img
                                                            src={image}
                                                            alt={productName}
                                                            className='h-full w-full object-scale-down p-3 sm:p-4'
                                                        />
                                                    </div>
                                                </Link>

                                                {/* Product Details */}
                                                <div className='flex-grow min-w-0'>
                                                    <div className='flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2'>
                                                        <div className='flex-1'>
                                                            <Link 
                                                                to={`/product/${productId}`}
                                                                className='block'
                                                            >
                                                                <h3 
                                                                    className='font-normal text-base sm:text-lg text-neutral-900 tracking-tight hover:opacity-70 transition-opacity line-clamp-2'
                                                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                                                >
                                                                    {productName}
                                                                </h3>
                                                            </Link>
                                                            <p 
                                                                className='text-xs sm:text-sm text-neutral-600 mt-1'
                                                                style={{ fontFamily: 'Georgia, serif' }}
                                                            >
                                                                {category}
                                                            </p>
                                                            
                                                            {/* Display Variants */}
                                                            {variants.length > 0 && (
                                                                <div className='mt-2 sm:mt-3 flex flex-wrap gap-1 sm:gap-2'>
                                                                    {variants.map((variant, idx) => (
                                                                        <span
                                                                            key={idx}
                                                                            className='px-2 py-1 text-xs tracking-wide bg-neutral-900 text-neutral-200'
                                                                            style={{ fontFamily: 'Georgia, serif' }}
                                                                        >
                                                                            {variant}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Price - Mobile & Desktop */}
                                                        <div className='flex justify-between items-center sm:block sm:text-right'>
                                                            <div className='sm:hidden'>
                                                                <p 
                                                                    className='font-normal text-base text-neutral-900'
                                                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                                                >
                                                                    {displayNGNCurrency(price)}
                                                                </p>
                                                                <p 
                                                                    className='text-xs text-neutral-500 mt-1'
                                                                    style={{ fontFamily: 'Georgia, serif' }}
                                                                >
                                                                    Each
                                                                </p>
                                                            </div>
                                                            <div className='hidden sm:block'>
                                                                <p 
                                                                    className='font-normal text-lg text-neutral-900'
                                                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                                                >
                                                                    {displayNGNCurrency(price)}
                                                                </p>
                                                                <p 
                                                                    className='text-sm text-neutral-500 mt-1'
                                                                    style={{ fontFamily: 'Georgia, serif' }}
                                                                >
                                                                    Each
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Quantity Control & Actions */}
                                                    <div className='flex flex-col sm:flex-row sm:justify-between sm:items-center mt-4 sm:mt-6 gap-4 sm:gap-0'>
                                                        {/* Quantity Selector */}
                                                        <div className='flex items-center justify-between sm:justify-start sm:gap-4'>
                                                            <div className='flex items-center gap-2 sm:gap-4'>
                                                                <div 
                                                                    className='flex items-center gap-2 px-3 sm:px-4 py-2 border border-neutral-300 bg-white'
                                                                >
                                                                    <button
                                                                        onClick={() => handleUpdateQuantity(cartItemId, quantity - 1)}
                                                                        disabled={quantity <= 1 || isUpdating}
                                                                        className='p-1 transition-all hover:scale-110 disabled:opacity-50 text-neutral-600'
                                                                    >
                                                                        <FaMinus size={12} className='sm:w-3 sm:h-3' />
                                                                    </button>
                                                                    <span 
                                                                        className='font-medium text-sm text-neutral-900 w-6 sm:w-8 text-center'
                                                                        style={{ fontFamily: 'Georgia, serif' }}
                                                                    >
                                                                        {quantity}
                                                                    </span>
                                                                    <button
                                                                        onClick={() => handleUpdateQuantity(cartItemId, quantity + 1)}
                                                                        disabled={isUpdating}
                                                                        className='p-1 transition-all hover:scale-110 disabled:opacity-50 text-neutral-600'
                                                                    >
                                                                        <FaPlus size={12} className='sm:w-3 sm:h-3' />
                                                                    </button>
                                                                </div>

                                                                {/* Item Total - Mobile only */}
                                                                <div className='sm:hidden'>
                                                                    <p 
                                                                        className='font-medium text-xs text-neutral-600'
                                                                        style={{ fontFamily: 'Georgia, serif' }}
                                                                    >
                                                                        Item Total:
                                                                    </p>
                                                                    <p 
                                                                        className='font-normal text-sm text-neutral-900'
                                                                        style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                                                    >
                                                                        {displayNGNCurrency(quantity * price)}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            {/* Item Total - Desktop only */}
                                                            <div className='hidden sm:block'>
                                                                <p 
                                                                    className='font-medium text-sm text-neutral-600'
                                                                    style={{ fontFamily: 'Georgia, serif' }}
                                                                >
                                                                    Item Total:
                                                                </p>
                                                                <p 
                                                                    className='font-normal text-lg text-neutral-900'
                                                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                                                >
                                                                    {displayNGNCurrency(quantity * price)}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        {/* Remove Button */}
                                                        <button
                                                            onClick={() => handleRemoveCart(cartItemId)}
                                                            disabled={isRemoving}
                                                            className='px-3 sm:px-4 py-2 border border-red-700 text-red-700 text-xs sm:text-sm uppercase tracking-wider font-medium transition-all hover:scale-105 hover:bg-red-50 disabled:opacity-50 flex items-center justify-center gap-1 sm:gap-2'
                                                            style={{ fontFamily: 'Georgia, serif' }}
                                                        >
                                                            <Trash2 size={14} className='sm:w-4 sm:h-4' />
                                                            <span className='sm:inline'>Remove</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Order Summary - Full width on mobile, 1/3 on desktop */}
                        <div className='lg:col-span-1'>
                            <div 
                                className='p-6 sm:p-8 border border-neutral-300 bg-white rounded-lg lg:sticky lg:top-28'
                            >
                                {/* Order Summary Title */}
                                <h2 
                                    className='text-xl font-normal mb-6 text-neutral-900 tracking-tight'
                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                >
                                    Order Summary
                                </h2>

                                {/* Summary Details */}
                                <div className='space-y-4 mb-6 sm:mb-8 pb-6 sm:pb-8 border-b border-neutral-300'>
                                    {/* Items Count */}
                                    <div className='flex justify-between text-sm'>
                                        <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                            Items ({data.length})
                                        </span>
                                        <span 
                                            className='font-medium text-neutral-900'
                                            style={{ fontFamily: 'Georgia, serif' }}
                                        >
                                            {displayNGNCurrency(calculateTotal())}
                                        </span>
                                    </div>

                                    {/* Shipping */}
                                    <div className='flex justify-between text-sm'>
                                        <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                            Shipping
                                        </span>
                                        <span 
                                            className='font-medium text-emerald-700'
                                            style={{ fontFamily: 'Georgia, serif' }}
                                        >
                                            Free
                                        </span>
                                    </div>

                                    {/* Estimated Tax */}
                                    <div className='flex justify-between text-sm'>
                                        <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                            Estimated Tax
                                        </span>
                                        <span 
                                            className='font-medium text-neutral-900'
                                            style={{ fontFamily: 'Georgia, serif' }}
                                        >
                                            {displayNGNCurrency(calculateTotal() * 0.075)}
                                        </span>
                                    </div>
                                </div>

                                {/* Total */}
                                <div className='mb-6 sm:mb-8'>
                                    <div className='flex justify-between text-base sm:text-lg'>
                                        <span 
                                            className='font-normal text-neutral-900'
                                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                        >
                                            Total Amount:
                                        </span>
                                        <span 
                                            className='font-normal text-xl sm:text-2xl text-neutral-900'
                                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                                        >
                                            {displayNGNCurrency(calculateTotal() + (calculateTotal() * 0.075))}
                                        </span>
                                    </div>
                                    <p className='text-xs text-neutral-500 mt-2' style={{ fontFamily: 'Georgia, serif' }}>
                                        Includes all applicable taxes and fees
                                    </p>
                                </div>

                                {/* Benefits - Hidden on mobile, shown on tablet and desktop */}
                                <div className='hidden sm:block space-y-4 mb-8'>
                                    <h3 className='text-sm font-medium text-neutral-600 uppercase tracking-wider' style={{ fontFamily: 'Georgia, serif' }}>
                                        Secure Shopping
                                    </h3>
                                    <div className='grid grid-cols-3 gap-3'>
                                        {[
                                            { icon: FaTruck, text: 'Free Shipping', color: 'text-emerald-700' },
                                            { icon: FaLock, text: 'Secure Payment', color: 'text-neutral-900' },
                                            { icon: FaStar, text: 'Premium Support', color: 'text-amber-600' }
                                        ].map((benefit, i) => (
                                            <div key={i} className='text-center'>
                                                <div 
                                                    className='p-3 mb-2 mx-auto border border-neutral-300 rounded-lg w-fit'
                                                >
                                                    <benefit.icon size={20} className={benefit.color} />
                                                </div>
                                                <span className='text-xs text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                    {benefit.text}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Checkout Button */}
                                <Link
                                    to="/checkout"
                                    className='w-full py-3 sm:py-4 text-xs sm:text-sm uppercase tracking-wider font-medium text-neutral-200 transition-all hover:scale-[1.02] hover:shadow-lg flex items-center justify-center gap-2 sm:gap-3 mb-3 bg-neutral-900 border border-neutral-900'
                                    style={{ fontFamily: 'Georgia, serif' }}
                                >
                                    <ShoppingCart size={16} className='sm:w-5 sm:h-5' />
                                    Proceed to Checkout
                                </Link>

                                {/* Continue Shopping */}
                                <Link
                                    to="/"
                                    className='w-full py-2 sm:py-3 text-xs sm:text-sm uppercase tracking-wider font-medium text-center border-2 border-neutral-900 text-neutral-900 transition-all hover:bg-neutral-50'
                                    style={{ fontFamily: 'Georgia, serif' }}
                                >
                                    Continue Shopping
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Bottom Checkout Bar - Only visible on mobile */}
            {data.length > 0 && (
                <div className='lg:hidden fixed bottom-0 left-0 right-0 border-t border-neutral-300 bg-white p-4 shadow-lg'>
                    <div className='flex justify-between items-center'>
                        <div>
                            <p className='text-sm text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                Total:
                            </p>
                            <p 
                                className='font-normal text-lg text-neutral-900'
                                style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                            >
                                {displayNGNCurrency(calculateTotal() + (calculateTotal() * 0.075))}
                            </p>
                        </div>
                        <Link
                            to="/checkout"
                            className='px-6 py-3 text-sm uppercase tracking-wider font-medium text-neutral-200 bg-neutral-900 border border-neutral-900 transition-all hover:scale-105'
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            Checkout
                        </Link>
                    </div>
                </div>
            )}

            {/* Add padding to bottom for mobile checkout bar */}
            <div className='lg:hidden pb-20' />

            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                div {
                    animation: fadeIn 0.3s ease-out;
                }

                /* Prevent horizontal scrolling on mobile */
                @media (max-width: 640px) {
                    .container {
                        overflow-x: hidden;
                    }
                }
            `}</style>
        </div>
    );
}

export default Cart;